import { makeVar } from '@apollo/client';
import { PlanTier } from '@fytness/shared';

/**
 * The current user's plan tier, mirrored from RevenueCat entitlements by the Purchases
 * context, for client-side tier-aware UI.
 *
 * NOTE (security): the PowerSync history window is NOT enforced from here. `connect()`
 * params are client-supplied and spoofable, so the cutoff is sourced server-side from the
 * trusted `history_from` access-token claim set by the Zitadel "setHistoryFrom"
 * complement-token action (derived from the RevenueCat entitlement via the
 * `unlimited_history` user metadata core-engine writes). See
 * infra/terraform/modules/zitadel/actions/set-history-from.js and the PowerSync sync rules.
 */
export const tierVar = makeVar<PlanTier>('free');
